module.exports = __webpack_public_path__ + "img/graph-db.a6a247e7.svg";